<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        name="name"
        disabled
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="who_uploaded"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.who_uploaded"
        :items="optionUserItems"
        text-field="email"
        value-field="id"
        sort-field="email"
        :form-state="formState"
        :loading="optionUserWorking"
        name="who_uploaded"
        disabled
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.who_uploaded"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="when_uploaded"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.when_uploaded"
        name="when_uploaded"
        disabled
        v-bind="schema.fields.when_uploaded"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="file_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.file_type"
        :items="optionCodeFileTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeFileTypeWorking"
        name="file_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.file_type"
        allow-add
        store-name="CodeFileType"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-file-type-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-file-type-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="parent_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.parent_type"
        :form-state="formState"
        name="parent_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.parent_type"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="parent_id"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-number-field
        v-model="item.parent_id"
        :form-state="formState"
        name="parent_id"
        :validators="$v.item"
        :server-errors="_se"
        step="1"
        v-bind="schema.fields.parent_id"
      ></o-number-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="_is_deleted"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-checkbox
        v-model="item._is_deleted"
        :form-state="formState"
        name="_is_deleted"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields._is_deleted"
      ></o-checkbox>
    </o-widget-wrapper>

    <preview :item="item" width="100%" height="900px" />

    <o-widget-wrapper
      :schema="schema"
      name="file_size"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.file_size"
        :form-state="formState"
        name="file_size"
        disabled
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.file_size"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="content_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.content_type"
        :form-state="formState"
        name="content_type"
        disabled
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.content_type"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="created_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.created_date"
        name="created_date"
        v-bind="schema.fields.created_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="modified_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.modified_date"
        name="modified_date"
        v-bind="schema.fields.modified_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index.js";
import { cleanUpModel } from "@/vue-ocom/schema/schema_vuetify.js";

import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "@/vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "@/vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "@/vue-ocom/components/forms/fields/OTextField.vue";
import ONumberField from "@/vue-ocom/components/forms/fields/ONumberField.vue";
import OSelect from "@/vue-ocom/components/forms/fields/OSelect.vue";
import OCheckbox from "@/vue-ocom/components/forms/fields/OCheckbox.vue";
import OFormWrapper from "@/vue-ocom/components/forms/OFormWrapper.vue";
import ODateTime from "@/vue-ocom/components/forms/fields/ODateTime.vue";

import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";

import { default as CodeFileTypeForm } from "../../code_file_type/components/ItemForm";
import Preview from "./Preview.vue";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("FileUpload"),
    UseCodeModulesMixin(["User", "CodeFileType"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    ONumberField,

    CodeFileTypeForm,
    Preview,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.FileUpload, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
